module.exports = __webpack_public_path__ + "static/media/closeSvg.71477c34.svg";